exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".l-cross-sellings-arrow{cursor:pointer}.l-cross-sellings{min-height:272px}", ""]);

// exports
